// Vendor imports
const qs = require('qs')
// Client lib imports
const businessEvents = require('client/lib/business-events')
// Client V2 common imports
const commonClient = require('client-v2/common/client')
const newUserTooltipActions = require('client-v2/common/containers/tooltips/actions/new-user')
const verifiedCuratorTooltipActions = require('client-v2/common/containers/tooltips/actions/verified-curator-badge')
// Entry imports
const configureStore = require('./state/store')
const rootFactory = require('./components/root').factory
const { showArticleProfileModal } = require('./containers/feed/actions')

commonClient.runAfterPageIsLoaded(() => {

  const { store } = commonClient.render(configureStore, rootFactory)

  const initialState = store.getState()

  const businessEventsPageActions = {
    'user-profile.showCollectionsCreated': 'mixes',
    'user-profile.showCollectionsSubscribed': 'followingMixes',
    'user-profile.showFollowers': 'followers',
    'user-profile.showFriends': 'friends',
    'user-profile.showPosts': 'posts'
  }
  const pageAction = businessEventsPageActions[initialState.router.action]
  commonClient.configureSession(store, {
    pageName: `user.${pageAction}`,
    streamId: initialState.profileUser.id,
    streamType: 'user'
  })

  businessEvents.trackProtobuf('TrackUserProfileView', {
    userId: initialState.user.id,
    profileUserId: initialState.profileUser.id
  })
  businessEvents.trackSegment('pageview')

  store.dispatch(newUserTooltipActions.showUserProfileFollowTooltip())

  if (initialState.profileUser.isVerifiedCurator) {
    store.dispatch(verifiedCuratorTooltipActions.showUserProfileBadgeTooltip())
  }

  const queryParams = qs.parse(location.search, { ignoreQueryPrefix: true })
  if (pageAction === 'posts' && queryParams.modal) {
    store.dispatch(showArticleProfileModal({ urlId: queryParams['url_id'] }))
  }

})
